module.exports = __webpack_public_path__ + "img/services_icon.049dea45.svg";